/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { shouldSendAnalyticsEvents } from '../shouldSendAnalyticsEvents/shouldSendAnalyticsEvents';
import type { EditorPlugins } from '../../types/EditorPlugins';
import type { GTM_EVENT_CONVERSION, GTM_EVENT_INSTALLATION_SUMMARY } from '../../constants/GTMEventNames';

export type StatsEvent = {
	event_type: typeof GTM_EVENT_INSTALLATION_SUMMARY | typeof GTM_EVENT_CONVERSION;
	event_data: {
		action?: string;
		stage?: string;
		group?: string;
		session_id: string;
		preset: string;
		is_dirty: boolean;
		editor_plugins: EditorPlugins;
		real_time: boolean;
		menu_bar: boolean;
		wrapped: boolean;
		additional_block: boolean;
		additional_balloon: boolean;
	};
	environment: 'production' | 'nightly' | 'staging' | 'development';
};

export async function triggerStatsEvent( event: StatsEvent ): Promise<void> {
	// @ts-expect-error STATS_EVENT_URL variable is injected by vite.
	const statsEventUrl = STATS_EVENT_URL;

	if ( !statsEventUrl ) {
		return;
	}

	if ( !shouldSendAnalyticsEvents() ) {
		return;
	}

	await fetch( statsEventUrl, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify( event )
	} ).catch( () => {} );
}
